// A page's code arrives as a separate chunk. After a redeploy (or a dev-server edit) that chunk can be gone, or out
// of step with the modules it imports; the browser then caches the failed module, so only a reload retries it.
const MODULE_LOAD = [
  /failed to fetch dynamically imported module/i, // Chromium
  /error loading dynamically imported module/i, // Firefox
  /importing a module script failed/i, // Safari
  /does not provide an export named/i, // a chunk newer or older than the module importing it
  /unable to preload css/i, // Vite's preload helper
];

/** A failed page-code load, as opposed to an error the page itself raised while rendering. */
export function isModuleLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.name === "ChunkLoadError" || MODULE_LOAD.some((pattern) => pattern.test(error.message));
}
